/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { toRefs, ref, watch } from '@vue/composition-api';
import { useConfig } from '../../config-provider/useConfig.js';
import { Pagination } from '../../pagination/index.js';
import '../../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../../_chunks/dep-9849f16c.js';
import '../../config-provider/type.js';
import '../../pagination/pagination.js';
import '../../_chunks/dep-1461d230.js';
import 'tdesign-icons-vue';
import '../../utils/mixins.js';
import 'vue';
import '../../config-provider/config-receiver.js';
import '../../input-number/index.js';
import '../../input-number/input-number.js';
import '../../button/index.js';
import '../../button/button.js';
import '../../loading/index.js';
import '../../loading/directive.js';
import 'lodash/isObject';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../../loading/plugin.js';
import '../../loading/loading.js';
import '../../loading/icon/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/isString';
import 'lodash/isNull';
import 'lodash/isUndefined';
import 'lodash/isNumber';
import 'lodash/isArray';
import '../../utils/dom.js';
import 'raf';
import '../../utils/easing.js';
import '../../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../utils/transfer-dom.js';
import '../../loading/props.js';
import '../../config.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../loading/type.js';
import '../../button/props.js';
import '../../utils/ripple.js';
import '../../button/type.js';
import '../../input/index.js';
import '../../input/input.js';
import '../../utils/helper.js';
import '../../utils/event.js';
import '../../input/props.js';
import '../../_common/js/log/index.js';
import '../../_common/js/log/log.js';
import '../../input/input-group.js';
import '../../utils/map-props.js';
import '../../input/type.js';
import '../../input-number/props.js';
import '../../input-number/useInputNumber.js';
import '../../hooks/useCommonClassName.js';
import '../../hooks/useVModel.js';
import '../../_common/js/input-number/number.js';
import '../../_common/js/input-number/large-number.js';
import '../../hooks/useFormDisabled.js';
import '../../hooks/useGlobalIcon.js';
import '../../hooks/useConfig.js';
import '../../input-number/type.js';
import '../../select/index.js';
import '../../select/select.js';
import 'lodash/isFunction';
import 'lodash/debounce';
import 'lodash/get';
import 'lodash/cloneDeep';
import '../../hooks/useDefaultValue.js';
import '../../hooks/tnode.js';
import 'lodash/isEmpty';
import '../../hooks/render-tnode.js';
import '../../select/props.js';
import '../../popup/index.js';
import '../../popup/popup.js';
import '@popperjs/core';
import '../../popup/props.js';
import '../../popup/container.js';
import '../../popup/utils.js';
import '../../popup/type.js';
import '../../popup/plugin.js';
import '../../tag/index.js';
import '../../tag/tag.js';
import '../../tag/props.js';
import '../../tag/check-tag.js';
import '../../tag/check-tag-props.js';
import '../../tag/type.js';
import '../../select-input/index.js';
import '../../select-input/select-input.js';
import '../../select-input/props.js';
import '../../select-input/useSingle.js';
import 'lodash/pick';
import '../../select-input/useMultiple.js';
import '../../tag-input/index.js';
import '../../tag-input/tag-input.js';
import '../../tag-input/props.js';
import '../../tag-input/hooks/useTagScroll.js';
import '../../tag-input/useTagList.js';
import '../../tag-input/hooks/useHover.js';
import '../../tag-input/hooks/useDragSorter.js';
import '../../tag-input/type.js';
import '../../tag-input/interface.js';
import '../../select-input/useOverlayInnerStyle.js';
import '../../select-input/type.js';
import '../../common-components/fake-arrow.js';
import '../../select/option.js';
import '../../select/option-props.js';
import '../../checkbox/index.js';
import '../../checkbox/group.js';
import 'lodash/intersection';
import '../../checkbox/checkbox.js';
import '../../checkbox/props.js';
import '../../hooks/index.js';
import '../../hooks/slots.js';
import '../../hooks/useDestroyOnClose.js';
import '../../hooks/useElementLazyRender.js';
import '../../_common/js/utils/observe.js';
import '../../hooks/useLazyLoad.js';
import '../../hooks/useResizeObserver.js';
import '../../hooks/useVirtualScrollNew.js';
import '../../hooks/useImagePreviewUrl.js';
import '../../_common/js/upload/utils.js';
import '../../checkbox/constants.js';
import '../../checkbox/store.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../../checkbox/hooks/useKeyboardEvent.js';
import '../../checkbox/checkbox-group-props.js';
import '../../checkbox/type.js';
import '../../select/util.js';
import '../../select/select-panel.js';
import '../../select/optionGroup.js';
import '../../select/option-group-props.js';
import '../../hooks/useVirtualScroll.js';
import '../../select/hooks/useSelectOptions.js';
import '../../select/type.js';
import '../../input-adornment/index.js';
import '../../input-adornment/input-adornment.js';
import '../../input-adornment/props.js';
import '../../input-adornment/type.js';
import '../../pagination/props.js';
import '../../pagination/pagination-mini.js';
import '../../pagination/pagination-mini-props.js';
import '../../pagination/type.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function usePagination(props, context) {
  var _pagination$value, _pagination$value2, _props$data;
  var _toRefs = toRefs(props),
    pagination = _toRefs.pagination,
    data = _toRefs.data,
    disableDataPage = _toRefs.disableDataPage;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var innerPagination = ref(props.pagination);
  var pageSize = ((_pagination$value = pagination.value) === null || _pagination$value === void 0 ? void 0 : _pagination$value.pageSize) || ((_pagination$value2 = pagination.value) === null || _pagination$value2 === void 0 ? void 0 : _pagination$value2.defaultPageSize) || 10;
  var dataSource = ref(((_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.slice(0, pageSize)) || []);
  var isPaginateData = ref(false);
  var updateDataSourceAndPaginate = function updateDataSourceAndPaginate() {
    var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var pageSize2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var data2 = props.data;
    var t = Boolean(!disableDataPage.value && data2.length > pageSize2);
    isPaginateData.value = t;
    if (t) {
      var start = (current - 1) * pageSize2;
      var end = current * pageSize2;
      dataSource.value = data2.slice(start, end);
    } else {
      dataSource.value = data2;
    }
    return dataSource.value;
  };
  watch(function () {
    var _pagination$value3, _pagination$value4;
    return [(_pagination$value3 = pagination.value) === null || _pagination$value3 === void 0 ? void 0 : _pagination$value3.current, (_pagination$value4 = pagination.value) === null || _pagination$value4 === void 0 ? void 0 : _pagination$value4.pageSize, data.value.length, disableDataPage];
  }, function () {
    if (!pagination.value || !pagination.value.current) return;
    updateDataSourceAndPaginate(pagination.value.current, pagination.value.pageSize);
  }, {
    immediate: true
  });
  watch([data], function () {
    var _innerPagination$valu, _innerPagination$valu2;
    if (!pagination.value || !pagination.value.defaultCurrent) return;
    var isControlled = Boolean(pagination.value.current);
    if (isControlled) return;
    updateDataSourceAndPaginate((_innerPagination$valu = innerPagination.value.current) !== null && _innerPagination$valu !== void 0 ? _innerPagination$valu : pagination.value.defaultCurrent, (_innerPagination$valu2 = innerPagination.value.pageSize) !== null && _innerPagination$valu2 !== void 0 ? _innerPagination$valu2 : pagination.value.defaultPageSize);
  }, {
    immediate: true
  });
  var renderPagination = function renderPagination(h) {
    if (!pagination.value) return null;
    return h("div", {
      "class": "".concat(classPrefix.value, "-table__pagination")
    }, [h(Pagination, {
      "props": _objectSpread({}, pagination.value),
      "on": _objectSpread({}, {
        change: function change(pageInfo) {
          var _props$onPageChange;
          Object.assign(innerPagination.value, pageInfo);
          updateDataSourceAndPaginate(pageInfo.current, pageInfo.pageSize);
          context.emit("page-change", pageInfo, dataSource.value);
          (_props$onPageChange = props.onPageChange) === null || _props$onPageChange === void 0 || _props$onPageChange.call(props, pageInfo, dataSource.value);
        }
      }),
      "scopedSlots": {
        totalContent: context.slots.totalContent
      }
    })]);
  };
  return {
    isPaginateData: isPaginateData,
    dataSource: dataSource,
    innerPagination: innerPagination,
    renderPagination: renderPagination
  };
}

export { usePagination as default };
//# sourceMappingURL=usePagination.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/table/hooks/usePagination.js
// module id = null
// module chunks = 